import DataGrid from "./DataGrid/DataGrid.tsx";

interface DocumentPPPData {
  PolNum: string;
  InsComp: string;
  DocType: string;
  DateR: string;
}

interface DocumentsPPPDataGridProps {
  documents: DocumentPPPData[];
  isLoading: boolean;
  printMetadata?: { label: string; value: string }[];
  printFooterMetadata?: { label: string; value: string }[];
}

const DocumentsPPPDataGrid = ({
  documents,
  isLoading,
  printMetadata,
  printFooterMetadata,
}: DocumentsPPPDataGridProps) => {
  const columns = [
    {
      name: "PolNum",
      header: "Номер на Полица",
      type: "string",
    },
    { name: "InsComp", header: "ЗК", type: "string" },
    { name: "DocType", header: "Вид Документ", type: "string" },
    { name: "Agent", header: "Агент", type: "string" },
    { name: "DateR", header: "Дата на Отчет", type: "string" },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={documents}
      isLoading={isLoading}
      gridTitle="ППП Документи"
      idProperty="PolNum"
      csvFilename="PPP.csv"
      onEditComplete={undefined}
      printReportMetadata={printMetadata}
      printReportFooterMetadata={printFooterMetadata}
    />
  );
};

export default DocumentsPPPDataGrid;
